import React, { useEffect } from "react";

import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { Grid, Box, Container, Button } from "@mui/material";
import AddBudgetDialog from "../Pages/AddBudgetDialog/AddBudgetDialog";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { months } from "../helpers/constants";

//Components
import TopMenu from "./TopMenu";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { varsActions } from "../actions/vars.action";
import { userActions } from "../actions/user.actions";
import { calculateFebDays } from "../helpers/common";


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Header = (props) => {
  const [month, setMonth] = React.useState(""); // It stores month name in string
  const [year, setYear] = React.useState(new Date().getFullYear()); // '2023-01-05'
  const [monthId, setMonthId] = React.useState(""); // Value stores from 0 - 11
  const [endDate, setEndDate] = React.useState({});
  const [monthChange, setMonthChange] = React.useState(false);

  const dispatch = useDispatch();
  const storeStartDate = useSelector((state) => state.varsReducer.startDate);
  // const storeEndDate = useSelector((state) => state.varsReducer.endDate);

  const setCurrentMonth = (mId) => {
    setMonth(months[mId-1].name);
  };
  // Component Did Mount
  useEffect(() => {
    setStartEndDate();
    props.fetchMonthlyTransaction();    
    updateUserAction(); // update value from localStorage to redux Store on page refresh.
  }, []);

  // Component Did Update
  useEffect(()=>{
    if(monthChange == false){
      setStartEndDate();
    }
    setMonthChange(false);
  }, [storeStartDate]);


  const setStartEndDate = () =>{
    const d = new Date(); //'2023-01-05'
    setYear(d.getFullYear());
    let curMonthId = d.getMonth() + 1;
    let curYear;
    if(d.getDate() < parseInt(localStorage.getItem("monthStartDate"))){
      if(d.getMonth() == 0){ // If its january and value is passing 0 in setCurrentMonth function
        setCurrentMonth(12);
        setMonthId(11);
        curMonthId = 12;
        setYear(year-1);
        curYear = year -1;
      } else {
        curMonthId = curMonthId - 1;
        curYear = year;
        setCurrentMonth(d.getMonth());
        setMonthId(d.getMonth());
      }
      dispatchStartDate(
        new Date(`${curYear}-${curMonthId}-${localStorage.getItem("monthStartDate")}`)
      );
      getEndDate(curMonthId, curYear);
    }
    else if (curMonthId == 12) {
      setMonthId(curMonthId);
      setCurrentMonth(curMonthId);
      curYear = year;
      dispatchStartDate(
        new Date(`${curYear}-${curMonthId}-${localStorage.getItem("monthStartDate")}`)
      );
      getEndDate(curMonthId, curYear);
    } else {
      setMonthId(curMonthId);
      setCurrentMonth(curMonthId);
      curYear = year;
      dispatchStartDate(
        new Date(
          `${year}-${curMonthId}-${localStorage.getItem("monthStartDate")}`
        )
      );
      getEndDate(curMonthId, curYear);
    }
  }

  function updateUserAction(){
    dispatch(
      userActions.updateUserData()
    );
  }

  const backMonth = () => {
    setMonthChange(true);
    const monthId = months.findIndex((item) => item.name == month);
    let monthVal;
    if (monthId == 0) {
      setMonthId(12);
      setCurrentMonth(12);
      monthVal = 12;
      setYear(year - 1);
      const yr = year - 1;
      dispatchStartDate(
        new Date(`${yr}-${12}-${localStorage.getItem("monthStartDate")}`)
      );

      getEndDate(12, yr);
    } else {
      setCurrentMonth(monthId);
      monthVal = monthId;
      setMonthId(monthVal);
      dispatchStartDate(
        new Date(
          `${year}-${monthId}-${localStorage.getItem("monthStartDate")}`
        )
      );

      getEndDate(monthId, year);
    }
    props.fetchMonthlyTransaction();
  };

  const getNextMonth = () => {
    setMonthChange(true);
    const monthId = months.findIndex((item) => item.name == month);
    let monthVal;
    if (monthId < 11) {
      setCurrentMonth(monthId + 2);
      monthVal = monthId + 2;
      setMonthId(monthVal);
      dispatchStartDate(
        new Date(
          `${year}-${monthVal}-${localStorage.getItem("monthStartDate")}`
        )
      );
      getEndDate(monthVal, year);
    } else {
      setCurrentMonth(1);
      monthVal = 1;
      setMonthId(monthVal);
      setYear(year + 1);
      const yr = year + 1;
      dispatchStartDate(
        new Date(
          `${yr}-${monthVal}-${localStorage.getItem("monthStartDate")}`
        )
      );
      getEndDate(monthVal, yr);
    }
    props.fetchMonthlyTransaction();
  };

  const getEndDate = (monthVal, yearVal) => { // value receives here in 1-12
    
    let days;
    if(monthVal == 2){
      days = calculateFebDays(yearVal) - 1;
    } else {
      days = months[monthVal - 1].days - 1;
    }
    var date = new Date(
      `${yearVal}-${monthVal}-${localStorage.getItem("monthStartDate")}`
    ); //.toISOString().split("T")[0]
    
    date.setDate(date.getDate() + days);
    setEndDate({
      date: date.getDate(),
      monthId: date.getMonth() + 1,
      monthString: months[date.getMonth()].name,
      year: date.getFullYear(),
    });
    dispatchEndDate(
      `${new Date(date).getFullYear()}-${
        (new Date(date).getMonth() + 1).toString().padStart(2, '0')
      }-${(new Date(date).getDate()).toString().padStart(2, '0')}`
    );
  };

  function dispatchStartDate(date) {
    dispatch(
      varsActions.setStartDate({
        startDate: `${date.getFullYear()}-${
          (date.getMonth() + 1).toString().padStart(2, '0')
        }-${(date.getDate()).toString().padStart(2, '0')}`,
      })
    );
  }

  function dispatchEndDate(date) {
    dispatch(
      varsActions.setEndDate({
        endDate: date,
      })
    );
  }

  return (
    <>
      <Grid container className="header-height">
        <Container maxWidth="lg" className="header-container">
          <Grid item xs={4}>
            <Link to="/">
              <img alt="logo" className="top-logo" src="https://jsonworld.com/moneytrek/images/logo.png" />
            </Link>
          </Grid>
          <Grid item xs={4} className="date-calender">
            <div style={{ display: "flex", alignItems : "center", justifyContent:"center" }}>
            <Button variant="outlined" className="header-dir-btn" onClick={(event) => backMonth()}>
              <ArrowBackIcon />
            </Button>
              
              <Box component="span" m="{1}" style={{padding:' 0px 5px'}}>
                {endDate.monthString ? (
                  <>
                    {localStorage.getItem("monthStartDate")}{" "}
                    {month.substring(0, 3)} - {endDate.date}{" "}
                    {endDate.monthString.substring(0, 3)}{" "}
                    {endDate.year.toString().substring(2, 5)}
                  </>
                ) : (
                  <></>
                )}
              </Box>
              <Button variant="outlined" className="header-dir-btn" onClick={(event) => getNextMonth()}>
                <ArrowForwardIcon />
              </Button>
              
            </div>
          </Grid>
          <Grid item xs={4}>
            <Box>
              <Grid
                container
                spacing={1}
                align="center"
                direction="row"
                className="header-right"
              >
                <Grid
                  item
                  xs={5}
                  childstyle={{ marginTop: 3 }}
                  className="Budget-button"
                >
                  <AddBudgetDialog />
                </Grid>
                <Grid item xs={2} className="userIconMenu">
                  <TopMenu />
                  {/* <Button onClick={logOutUser} variant="outlined">Logout<Logout fontSize="small"></Logout></Button> */}
                </Grid>
                {/* <Grid item xs={5} ></Grid> */}
              </Grid>
            </Box>
          </Grid>
        </Container>
      </Grid>
    </>
  );
};

export default Header;
